// Pure function to determine if we need to redirect and where
export function getRedirectPath(pathname, dashboardOnly, firebaseCredentials) {
  const currentPath = pathname;

  // Define paths exempt from redirection
  const exemptPaths = [
    "/embed",
    "/reset-password",
    "/auth-group",
    "/viewcontent",
    "/group/about",
    "/lead",
    "/discover",
    "/share",
    "/dashboard"
  ];

  // No redirect if on an exempt path or already on discover
  if (exemptPaths.some(path => currentPath.includes(path)) || currentPath.includes("discover")) {
    return null;
  }

  // Skip redirect if not in dashboard-only mode
  if (!dashboardOnly) {
    return null;
  }

  // All paths go to dashboard in dashboard-only mode
  return "/dashboard";
}
